import script from "./BarButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BarButton.vue?vue&type=script&lang=ts&setup=true"

import "./BarButton.vue?vue&type=style&index=0&id=0dab1170&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dab1170"]])

export default __exports__